// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"95353f25","496":"0d5ff734"}[chunkId] + ".chunk.js";
};